export default {
  name: 'Error',

  setup() {
    function handleReturnButton() {
      history.back();
    }

    return {
      handleReturnButton
    };
  }

};